


export default function databases(state = { databaseList: [], currentDatabase: null, currentDataSource: null, qpDataSource: null, databaseCheck: false, singleDatabaseCheck: false, databaseFilter: "sort|modifiedDate|desc" }, action) {
    switch (action.type) {
        case 'LOAD_PRESENTATIONS':
            return {
                ...state
            }
        case 'LOAD_PRESENTATION':
            return {
                ...state, qpDataSource: null,
            }
        case 'SET_DATABASES':
            return {
                ...state, databaseList: action.payload, databaseCheck: true,
            }
        case 'CLEAR_DATA_SOURCES':
            return {
                ...state, dataSourceList: [],
            }
        case 'SET_DATABASE':
            return {
                ...state, currentDatabase: action.connInfo
            }
        case 'SET_DATA_SOURCE':
            return {
                ...state, currentDataSource: action.payload
            }
        case 'SET_QUICKPICK_DATA_SOURCE':
            return {
                ...state, qpDataSource: action.qp,
            }
        case 'FLIP_DATABASES_SWITCH':
            return {
                ...state, databaseCheck: true,
            }
        case 'FLIP_SINGLE_DATABASE_SWITCH':
            return {
                ...state, singleDatabaseCheck: true,
            }
        case 'APPLY_FILTER_DATABASES':
            return {
                ...state, databaseFilter: action.payload,
            }
        case 'LOGOUT_USER':
            return {
                ...state, databaseList: [], currentDatabase: null, currentDataSource: null, qpDataSource: null, databaseCheck: false, singleDatabaseCheck: false, databaseFilter: "sort|modifiedDate|desc",
            }
        default:
            return state
    }
}
